/**
 * A grid of similar communities
 *
 * Used on the community creation form
 */

/**
 * React Redux
 */
import React, {useState} from 'react';

/**
 * Office UI Fabric
 */
import { List } from '@fluentui/react/lib/List';

/**
 * Components
 */
import SimilarCommunityCard from '../SimilarCommunityCardComponent/';
import CommunityPanelComponent from '../Community/CommunityPanelComponent';

const ROWS_PER_PAGE = 3;
const MAX_ROW_HEIGHT = 260;
const MAX_COL_WIDTH = 285;

interface Props {
  constants: any;
  profile: any;
  brandName: string;
  tooltipSponsoredBadge: string;
  similarCommunities: [];

  communityActionCreators: any;
  membersActionCreators: any;
  inviteMembersActionCreators: any;
  requestsActionCreators: any;

  onPanelDismiss?(): void;
  onSimilarCommunityClick(community: any): void;
}

const Similarity = (props: Props) => {
  const {
    constants,
    profile,
    brandName,
    similarCommunities,
    tooltipSponsoredBadge ,

    onSimilarCommunityClick,
    onPanelDismiss,

    communityActionCreators,
    membersActionCreators,
    inviteMembersActionCreators,
    requestsActionCreators,
  } = props;
  const [communityInPanel, setCommunityInPanel] = useState<any>(null);

  let columnCount = 0;
  let rowHeight = 0;

  const _onSimilarCommunityClick = (c: any) => {
    console.log('_onSimilarCommunityClick 2', c);
    setCommunityInPanel({
      initialValues: c,
      isCommunityPanelOpen: true,
    });
    // onSimilarCommunityClick?.(c);
  };

  const _onPanelDismiss = (c: any) => {
    console.log('_onPanelDismiss 2');
    setCommunityInPanel({
      initialValues: null,
      isCommunityPanelOpen: false,
    });
  };

  const getPageWidth = (): number => {
    if ( window.innerWidth < 1024 )
      return window.innerWidth - 150;
    else
      return window.innerWidth - 532;
  };

  const getItemCountForPage = (itemIndex: any, surfaceRect: any) => {
    if (itemIndex === 0) {
      const screenWidth = surfaceRect.width > 1 ? surfaceRect.width:getPageWidth();

      /**
       * Responsive layout for cards
       */
      if (screenWidth >= 640) {
        columnCount = Math.ceil(screenWidth / MAX_COL_WIDTH);
      } else if (screenWidth < 640 && screenWidth >= 480) {
        columnCount = 2;
      } else {
        columnCount = 1;
      }
      rowHeight = MAX_ROW_HEIGHT;
    }
    return columnCount * ROWS_PER_PAGE;
  };

  const getPageHeight = (itemIndex: any, surfaceRect: any) => {
    return rowHeight * ROWS_PER_PAGE;
  };

  const onRenderCell = (item: any, index: any) => {
    return (
        item.communityId && (
            <div
                className='ms-ListGrid-tile'
                data-is-focusable={true}
                style={{ width: 100 / columnCount + '%' }}
            >
              <div className='ms-ListGrid-sizer'>
                <div className='msListGrid-padder'>
                  <SimilarCommunityCard
                      onSimilarCommunityClick={_onSimilarCommunityClick}
                      tooltipSponsoredBadge={tooltipSponsoredBadge}
                      community={item}
                  />
                </div>
              </div>
            </div>
        )
    );
  };

  return (
    <div>
      <hr />
      <div className='h2'>Similar communities</div>
      <p>
        Based on the title you have entered, here are some similar communities
        that already exist in {brandName}
      </p>
      <CommunityPanelComponent
        community={communityInPanel}
        allMembers={[]}
        profile={profile}
        brandName={brandName}
        constants={constants}
        onPanelDismiss={_onPanelDismiss}

        CommunityEditModal={null}

        communityActionCreators={communityActionCreators}
        membersActionCreators={membersActionCreators}
        inviteMembersActionCreators={inviteMembersActionCreators}
        requestsActionCreators={requestsActionCreators}
      />
      <List
        className='ms-ListGrid'
        items={similarCommunities}
        getItemCountForPage={getItemCountForPage}
        getPageHeight={getPageHeight}
        renderedWindowsAhead={4}
        renderCount={12}
        onRenderCell={onRenderCell}
      />
      <hr />
    </div>
  );
};

export default Similarity;
